import React from 'react';
import { HiArrowUp, HiArrowDown, HiMinus } from 'react-icons/hi';
import { fmtMoney, fmtPct, directionClass } from '../utils/format';

const Arrow = ({ value }) => {
    if (value === 0 || value == null) return <HiMinus size={14} />;
    return value > 0 ? <HiArrowUp size={14} /> : <HiArrowDown size={14} />;
};

const KpiCard = ({ label, valueA, valueB, deltaPercent, deltaPp, upIsGood = true, isMoney = true }) => {
    const valueDisplay = isMoney ? fmtMoney(valueA) : fmtPct(valueA);
    const baseline = isMoney ? fmtMoney(valueB) : fmtPct(valueB);
    const cls = directionClass(deltaPercent ?? deltaPp ?? 0, { upIsGood });

    return (
        <div className={`fr-kpi-card ${cls}`}>
            <div className="fr-kpi-label">{label}</div>
            <div className="fr-kpi-value">{valueDisplay}</div>
            <div className="fr-kpi-baseline">vs {baseline}</div>
            <div className="fr-kpi-delta">
                <Arrow value={deltaPercent ?? deltaPp ?? 0} />
                {deltaPercent !== null && deltaPercent !== undefined && !isNaN(deltaPercent) ? (
                    <span>{fmtPct(Math.abs(deltaPercent), 1)}</span>
                ) : (
                    <span>{deltaPp !== null && deltaPp !== undefined ? `${Math.abs(deltaPp).toFixed(2)}pp` : '—'}</span>
                )}
            </div>
        </div>
    );
};

const KpiStrip = ({ comparison }) => {
    if (!comparison) return null;
    const { totals } = comparison;

    return (
        <div className="fr-kpi-strip">
            <KpiCard
                label="Sales"
                valueA={totals.sales.a.amount}
                valueB={totals.sales.b.amount}
                deltaPercent={totals.sales.deltaPercent}
                upIsGood
            />
            <KpiCard
                label="Gross Profit"
                valueA={totals.grossProfit.a.amount}
                valueB={totals.grossProfit.b.amount}
                deltaPercent={totals.grossProfit.deltaPercent}
                upIsGood
            />
            <KpiCard
                label="Gross Margin %"
                valueA={totals.grossProfit.a.percent}
                valueB={totals.grossProfit.b.percent}
                deltaPp={totals.grossProfit.deltaPp}
                upIsGood
                isMoney={false}
            />
            <KpiCard
                label="Indirect Expenses % of Sales"
                valueA={totals.indirectExpenses.a.percent}
                valueB={totals.indirectExpenses.b.percent}
                deltaPp={totals.indirectExpenses.deltaPp}
                upIsGood={false}
                isMoney={false}
            />
            <KpiCard
                label="Net Profit"
                valueA={totals.netProfit.a.amount}
                valueB={totals.netProfit.b.amount}
                deltaPercent={totals.netProfit.deltaPercent}
                upIsGood
            />
            <KpiCard
                label="Net Profit Margin"
                valueA={totals.netProfit.a.percent}
                valueB={totals.netProfit.b.percent}
                deltaPp={totals.netProfit.deltaPp}
                upIsGood
                isMoney={false}
            />
        </div>
    );
};

export default KpiStrip;
